import type { Key } from 'react-aria-components';
import type { Room } from '~/schemas/trip';
import { sanitzeBoardBasis } from '~/utils/accommodationHelpers';
import type { SortKeys } from './constants';

export function sortAndFilterRooms(
  rooms: Room[],
  { sortBy, selectedBoardBasis }: { sortBy?: SortKeys; selectedBoardBasis?: Set<Key> }
) {
  // filter duplicates by roomCode
  const uniqueRooms = rooms.filter((room, index, self) => index === self.findIndex((t) => t.id === room.id));

  // filter duplicates by roomCode
  const filteredRooms = uniqueRooms.filter((room) =>
    selectedBoardBasis?.size ? selectedBoardBasis?.has(sanitzeBoardBasis(room.boardBasis)) : true
  );

  const sortedRooms = filteredRooms.sort((a, b) => {
    switch (sortBy) {
      case 'price-asc':
        return (a.priceDifference?.value ?? 0) - (b.priceDifference?.value ?? 0);
      case 'price-desc':
        return (b.priceDifference?.value ?? 0) - (a.priceDifference?.value ?? 0);
      case 'name-asc':
        return a.roomName.localeCompare(b.roomName);
      case 'name-desc':
        return b.roomName.localeCompare(a.roomName);
      default:
        return 0;
    }
  });

  return sortedRooms;
}
